import { gql, useMutation } from "@apollo/client";

const TRACK_EVENT = gql`
  mutation($entity: Entity, $event: Event, $id: UUID) {
    trackEvent(entity: $entity, event: $event, id: $id)
  }
`;
const useTrackEvent = () => {
  return useMutation(TRACK_EVENT);
};

export default useTrackEvent;
